export default __webpack_public_path__ + "static/char-s-33-en-61ec256fb3f184b07a2b0868109a89a3.webp";